import { authApi } from './api';
import { LoginCredentials, RegisterData } from '../types';

export const login = async (credentials: LoginCredentials) => {
  const response = await authApi.login(credentials);
  const { access_token, refresh_token } = response.data;
  localStorage.setItem('token', access_token);
  localStorage.setItem('refreshToken', refresh_token);
  return response.data;
};

export const register = async (data: RegisterData) => {
  const response = await authApi.register(data);
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  window.location.replace('/login');
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export const getCurrentUser = async () => {
  const response = await authApi.getMe();
  return response.data;
};
